import React from "react";
import LayoutContentCenteredWithBackground from "../../components/Layouts/ContentCenteredWithBackgroundLayout";
import PasswordLostForm from "./PasswordLostForm";

export const route = "/password-lost";

function PasswordLostContainer() {
  return (
    <LayoutContentCenteredWithBackground>
      <PasswordLostForm />
    </LayoutContentCenteredWithBackground>
  );
}

PasswordLostContainer.route = route;

export default PasswordLostContainer;
